import { EPaymentChannel, IPageParam } from '../common';
import { ESettlementDetailIdType, ESettlementReceivedType } from '../settlement';

/**
 * 性别枚举
 */
export enum EPersonnelGender {
  /** 男 */
  Male = 1,
  /** 女 */
  Female = 2,
}

export const personnelGenderLabel = {
  [EPersonnelGender.Male]: '男',
  [EPersonnelGender.Female]: '女',
};

/**
 * 海外人员列表查询参数
 */
export interface IOverseasPersonneParams extends IPageParam {
  /** 海外人员名称 */
  personName?: string;
  /** 证件类型 */
  idType?: ESettlementDetailIdType;
  /** 证件号 */
  idNo?: string;
  /** 手机号 */
  personTel?: string;
  /** 合作服务商 */
  serverId?: string;
  /** 所属企业 */
  companyId?: string;
  /** 所属特代 */
  agentTopId?: string;
}

/**
 * 海外人员列表项
 */
export interface IOverseasPersonnelItem {
  id?: number;
  /** 海外人员编号 */
  customerNo?: string;
  /** 海外人员名称 */
  personName?: string;
  /** 证件类型 */
  idType?: ESettlementDetailIdType;
  /** 证件号 */
  idNo?: string;
  /** 银行卡号 */
  bankCard?: string;
  /** 手机号 */
  personTel?: string;
  /** 支付宝号 */
  alipayAccount?: string;
  /** 合作服务商 */
  serverNames?: string;
  /** 所属特代 */
  agentTopNames?: string;
  /** 所属企业 */
  companyNames?: string;
  /** 结算金额 */
  settlementAmount?: number;
}

/**
 * 海外人员详情
 */
export interface IOverseasPersonnelDetail extends IOverseasPersonnelItem {
  /** 国籍(地区) */
  country: string;
  /** 出生国家(地区) */
  birthCountry: string;
  /** 性别 */
  sex: EPersonnelGender;
  /** 出生日期 */
  birthDate: string;
  /** 证件照正面图片 */
  idFrontUrl?: string;
  /** 证件照反面图片 */
  idBackUrl?: string;
  /* 证件类型 */
  idType?: ESettlementDetailIdType;
}

/**
 * 选择海外人员查询参数（通过任务id和企业id）
 */
export interface ISelectOverseasPersonnelParams {
  /** 任务id */
  dutyId: number;
  /** 企业id */
  companyId: number;
  /** 搜索关键词（姓名/证件号） */
  searchKey?: string;
  /** 收款方式 */
  receivedType?: ESettlementReceivedType;
  /** 支付通道 */
  payType?: EPaymentChannel;
}

/**
 * 国家-地区列表
 */
export interface ICountryRegionItem {
  /** 国家-地区id */
  id: number;
  /** 国家-地区名称 */
  name: string;
}